import { render, staticRenderFns } from "./PromotionInvitation.vue?vue&type=template&id=679097e8"
import script from "./PromotionInvitation.vue?vue&type=script&lang=js"
export * from "./PromotionInvitation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports